import { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { translations } from "../data/translations";

const AppContext = createContext(null);

export const AppProvider = ({ children }) => {
  const [theme, setTheme] = useState(() => {
    if (typeof window === "undefined") return "light";
    return localStorage.getItem("cr-theme") || "dark";
  });
  const [lang, setLang] = useState(() => {
    if (typeof window === "undefined") return "es";
    return localStorage.getItem("cr-lang") || "es";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") root.classList.add("dark");
    else root.classList.remove("dark");
    localStorage.setItem("cr-theme", theme);
  }, [theme]);

  useEffect(() => {
    localStorage.setItem("cr-lang", lang);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const toggleTheme = useCallback(
    () => setTheme((t) => (t === "dark" ? "light" : "dark")),
    []
  );

  const t = translations[lang];

  // Memoize so consumers don't re-render on every provider render (the object
  // identity stays stable unless one of these values actually changes).
  const value = useMemo(
    () => ({ theme, toggleTheme, lang, setLang, t }),
    [theme, toggleTheme, lang, t]
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export const useApp = () => {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error("useApp must be used within AppProvider");
  return ctx;
};
